import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-50 mb-4">
            <i className="ri-question-answer-line text-secondary-500 text-sm"></i>
            <span className="text-secondary-600 text-xs font-medium">常见问题</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            关于<span className="text-primary-600">开云棋牌</span>的常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            快速了解您关心的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-foreground-400 text-lg flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}